import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "border-b border-background-200/80 bg-background-50/95 backdrop-blur"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-6 px-4 md:px-6">
        <h1 className="flex items-center gap-2">
          <a href="#top" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-flashlight-fill text-lg" />
            </span>
            <span
              className={`font-heading text-lg font-bold tracking-tight ${
                scrolled || open ? "text-foreground-950" : "text-background-50"
              }`}
            >
              黑料平台
            </span>
          </a>
        </h1>

        <nav className="hidden items-center gap-7 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap text-sm transition-colors ${
                scrolled
                  ? "text-foreground-600 hover:text-primary-600"
                  : "text-background-100/90 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <a
            href="#services"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-arrow-right-line" />
            进入平台
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-md border transition-colors md:hidden ${
            scrolled || open
              ? "border-background-300 text-foreground-800"
              : "border-background-100/40 text-background-50"
          }`}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between border-b border-background-200/70 py-3 text-sm text-foreground-700"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-foreground-400" />
              </a>
            ))}
          </nav>
          <a
            href="#services"
            onClick={() => setOpen(false)}
            className="mt-4 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50"
          >
            进入平台
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      ) : null}
    </header>
  );
}